module.exports = __webpack_public_path__ + "static/media/banner.7e17789f.png";